module.exports = __webpack_public_path__ + "static/media/Stock_Request_Template_1.fce73e94.png";